"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function stateId(state) {
    if (state === void 0) { state = 0; }
    return state + 1;
}
exports.default = stateId;
//# sourceMappingURL=stateId.js.map


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/lib/reducers/stateId.js
// module id = 1829
// module chunks = 0